/** Terminal state after submit. Identical for every visitor, so it can't reveal whether the email or DOT was already on file. */
export function ConfirmEmailPanel({ email }: { email: string }) {
  return (
    <div className="mx-auto flex max-w-2xl flex-col items-start gap-6 py-10">
      <h2 className="h3 text-ink-50">Please confirm your email to submit your info to a Cai broker.</h2>
      <p className="text-ink-200 text-lg leading-relaxed">
        We sent a link to <span className="text-brand-400 font-semibold">{email}</span>.
      </p>
      <p className="text-ink-300 border-ink-700 border-t pt-6 text-xs leading-normal">
        The link expires in a couple of hours. If it does not arrive, check your spam folder before trying
        again.
      </p>
    </div>
  )
}
